// About.js
import React from 'react';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';

const Join = () => {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Join
      </Typography>
      <Typography variant="body1">
        <Alert severity="success">
          If you are insterested in joining, please visit our parent organization at <a href="https://rlc.org/join-the-rlc/" target="_blank" rel="noopener noreferrer">Join</a>.
        </Alert>
      </Typography>
      <hr />
    </div>
  );
};

export default Join;